<template>
  <ion-page>
  <master-layout pageTitle="گزارشات درآمد">
    <ion-card-content>
      <Loading :is="!pageLoaded" v-if="!pageLoaded"></Loading>
      <div v-if="pageLoaded">
        <div v-if="items">
          <ion-grid>
            <ion-row>
              <ion-col size="6">
                <router-link to="/Report/ProductProfit" class="btn btn-square btn-sm btn-info">
                  <i class="fa fa-boxes"></i>
                  <div>سود فروش محصول</div>
                  <Money :number="items.p_benefit" ></Money>
                </router-link>
              </ion-col>
              <ion-col size="6">
                <router-link to="/Report/ServiceProfit" class="btn btn-square btn-sm btn-success">
                  <i class="fa fa-car-mechanic"></i>
                  <div>درآمد خدمات</div>
                  <Money :number="items.total_service_income" ></Money>
                </router-link>
              </ion-col>

              <ion-col size="6">
                <router-link to="/Report/wastageProfit" class="btn btn-square btn-sm btn-success">
                  <i class="fa fa-dumpster-fire"></i>
                  <div>فروش ضایعات</div>
                  <Money :number="items.wastage_total" ></Money>
                </router-link>
              </ion-col>

              <ion-col size="6">
                <div  class="btn btn-square btn-sm btn-info">
                  <i class="fa fa-chart-pie-alt"></i>
                  <div>درآمد کل</div>
                  <Money :number="items.total_income" ></Money>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <div v-if="error" class="alert alert-danger">
          {{error}}
        </div>
      </div>

    </ion-card-content>
  </master-layout>
  </ion-page>
</template>


<script>

import MainPageItem from '/src/components/MainPageItem'
import Money from '/src/components/Money'
import {
  IonCardContent, IonGrid, IonCol, IonRow,IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";

export default {
  components: {
    IonCardContent, IonGrid, IonCol, IonRow,IonPage , MainPageItem,Money
  },
  data(){
    return{
      pageLoaded : false,
      error : false,
      items : false,
    }
  },async created()
  {
    const result = await this.getIncomeReportItems();
    if (result)
    {
      if (result.ok)
      {
        this.pageLoaded = true;
        this.items = result;
      }
      else
      {
        this.customerLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.pageLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  methods: {
    ...mapActions("app", {
      getIncomeReportItems: 'getIncomeReportItems',
    }),
  },
};
</script>

<style scoped>
.btn-square {
  width: 100%;
  display: block;
  text-align: center;
  height: 150px !important;
}
.count {
  font-size: 18px;
  font-weight: 900;
}
</style>